/* ============================================
   SN4CK THEME — CORE JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- MOBILE MENU ---------- */
  window.openMob = function () {
    var m = document.getElementById('mobMenu');
    if (m) m.classList.add('open');
  };
  window.closeMob = function () {
    var m = document.getElementById('mobMenu');
    if (m) m.classList.remove('open');
  };

  /* ---------- GENERIC OVERLAY CLICK-OUTSIDE ---------- */
  window.handleOverlay = function (e, id) {
    if (e.target === document.getElementById(id)) {
      document.getElementById(id).classList.remove('open');
    }
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeWish();
      closeCartDrawer();
      closeModal();
    }
  });

  /* ---------- TOAST ---------- */
  window.showToast = function (msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(window._toastTimer);
    window._toastTimer = setTimeout(function () {
      t.classList.remove('show');
    }, 2400);
  };

  /* ---------- WISHLIST (browser-local, no account required) ---------- */
  function getWishlist() {
    try {
      var raw = localStorage.getItem('sn4ck_wishlist');
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem('sn4ck_wishlist', JSON.stringify(list)); } catch (e) {}
  }
  window.toggleWish = function (btn, handle, name, type, image) {
    var list = getWishlist();
    var idx = list.findIndex(function (i) { return i.handle === handle; });
    if (idx > -1) {
      list.splice(idx, 1);
      if (btn) btn.classList.remove('active');
      showToast('Removed from wishlist');
    } else {
      list.push({ handle: handle, name: name, type: type, image: image || '' });
      if (btn) btn.classList.add('active');
      showToast('Added to wishlist');
    }
    saveWishlist(list);
    updateWishCount();
    renderWish();
  };
  function updateWishCount() {
    var list = getWishlist();
    var el = document.getElementById('wishCount');
    if (!el) return;
    if (list.length > 0) { el.style.display = 'flex'; el.textContent = list.length; }
    else { el.style.display = 'none'; }
  }
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderWish() {
    var body = document.getElementById('wishBody');
    if (!body) return;
    var list = getWishlist();
    if (!list.length) {
      body.innerHTML = '<div class="drawer-empty">Your wishlist is empty.</div>';
      return;
    }
    body.innerHTML = list.map(function (item, i) {
      return '<div class="wish-item">' +
        '<div class="wish-thumb">' + (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.name) + '">' : '') + '</div>' +
        '<div class="wish-info">' +
          '<div class="wish-name">' + escapeHtml(item.name) + '</div>' +
          '<div class="wish-type">' + escapeHtml(item.type) + '</div>' +
          '<a href="/products/' + encodeURIComponent(item.handle) + '" style="font-size:10px;letter-spacing:2px;text-transform:uppercase;text-decoration:underline;display:block;margin-bottom:6px;">View Product</a>' +
          '<button class="wish-rm" data-idx="' + i + '">REMOVE</button>' +
        '</div>' +
      '</div>';
    }).join('');
    body.querySelectorAll('.wish-rm').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var list = getWishlist();
        list.splice(parseInt(btn.dataset.idx, 10), 1);
        saveWishlist(list);
        updateWishCount();
        renderWish();
      });
    });
  }
  window.openWish = function () {
    document.getElementById('wishOverlay').classList.add('open');
    renderWish();
  };
  window.closeWish = function () {
    var el = document.getElementById('wishOverlay');
    if (el) el.classList.remove('open');
  };
  window.isWished = function (handle) {
    return getWishlist().some(function (i) { return i.handle === handle; });
  };
  updateWishCount();

  /* ---------- SEARCH (Shopify predictive search) ---------- */
  var searchDebounce;
  window.openSearch = function () {
    var ov = document.getElementById('searchOverlay');
    if (!ov) return;
    ov.classList.add('open');
    var input = document.getElementById('searchInput');
    input.value = '';
    renderSearchEmpty();
    setTimeout(function () { input.focus(); }, 100);
  };
  window.closeSearch = function () {
    var ov = document.getElementById('searchOverlay');
    if (ov) ov.classList.remove('open');
  };
  function renderSearchEmpty() {
    var resultsEl = document.getElementById('searchResults');
    if (!resultsEl) return;
    resultsEl.innerHTML = '<div class="search-hint">Start typing to search products</div>';
  }
  function runSearch(query) {
    var resultsEl = document.getElementById('searchResults');
    if (!resultsEl) return;
    if (!query.trim()) { renderSearchEmpty(); return; }
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          resultsEl.innerHTML = '<div class="search-empty">No products found for "' + escapeHtml(query) + '"</div>';
          return;
        }
        resultsEl.innerHTML = '<div class="search-hint">' + products.length + ' Result' + (products.length === 1 ? '' : 's') + '</div>' +
          products.map(function (p) {
            return '<a href="' + p.url + '" class="search-result-item">' +
              '<div class="search-result-thumb">' + (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '">' : '') + '</div>' +
              '<div class="search-result-info">' +
                '<div class="search-result-name">' + escapeHtml(p.title).toUpperCase() + '</div>' +
                '<div class="search-result-type">' + escapeHtml(p.product_type || '') + '</div>' +
              '</div>' +
              '<div class="search-result-price">' + escapeHtml(p.price) + '</div>' +
            '</a>';
          }).join('');
      })
      .catch(function () {
        resultsEl.innerHTML = '<div class="search-empty">Search is unavailable right now.</div>';
      });
  }
  var searchInput = document.getElementById('searchInput');
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounce);
      var val = searchInput.value;
      searchDebounce = setTimeout(function () { runSearch(val); }, 250);
    });
  }

  /* ---------- SIZE SELECT MODAL (quick add from grid cards) ---------- */
  var pendingVariants = {};
  var pendingProductHandle = '';
  window.openSizeModal = function (btn) {
    var card = btn.closest('[data-product-handle]');
    if (!card) return;
    pendingProductHandle = card.dataset.productHandle;
    try { pendingVariants = JSON.parse(card.dataset.variantMap); } catch (e) { pendingVariants = {}; }
    document.getElementById('modalPname').textContent = card.dataset.productName;
    var sizeGrid = document.getElementById('sizeOptions');
    sizeGrid.innerHTML = Object.keys(pendingVariants).map(function (size) {
      var v = pendingVariants[size];
      var disabled = !v.available ? 'disabled' : '';
      return '<button class="sz" data-size="' + size + '" ' + disabled + '>' + size + '</button>';
    }).join('');
    sizeGrid.querySelectorAll('.sz:not(:disabled)').forEach(function (b) {
      b.addEventListener('click', function () {
        sizeGrid.querySelectorAll('.sz').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
      });
    });
    document.getElementById('sizeModal').classList.add('open');
  };
  window.closeModal = function () {
    var el = document.getElementById('sizeModal');
    if (el) el.classList.remove('open');
  };
  window.confirmModalAdd = function () {
    var sel = document.querySelector('#sizeOptions .sz.on');
    if (!sel) { showToast('Please select a size'); return; }
    var size = sel.dataset.size;
    var variantId = pendingVariants[size].id;
    addToCartAjax(variantId, 1, function () {
      showToast('Added to bag');
      closeModal();
    });
  };
  /* ---------- SHOPIFY CART AJAX API ---------- */
  window.addToCartAjax = function (variantId, qty, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var msg = (data && data.description) || 'Could not add that to your bag';
            throw new Error(msg);
          }
          return data;
        });
      })
      .then(function () {
        refreshCartCount();
        if (callback) callback();
      })
      .catch(function (err) {
        showToast(err.message || 'Something went wrong adding that to your bag');
      });
  };

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var el = document.getElementById('cartCount');
        if (!el) return;
        if (cart.item_count > 0) { el.style.display = 'flex'; el.textContent = cart.item_count; }
        else { el.style.display = 'none'; }
        renderCartDrawer(cart);
      })
      .catch(function () {});
  }
  refreshCartCount();

  /* ---------- CART DRAWER ---------- */
  window.openCartDrawer = function () {
    document.getElementById('cartDrawerOverlay').classList.add('open');
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCartDrawer);
  };
  window.closeCartDrawer = function () {
    var el = document.getElementById('cartDrawerOverlay');
    if (el) el.classList.remove('open');
  };
  function renderCartDrawer(cart) {
    var body = document.getElementById('cartDrawerBody');
    var totalEl = document.getElementById('cartDrawerTotal');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer-empty">Your bag is empty.</div>';
      if (totalEl) totalEl.textContent = formatMoney(0);
      return;
    }
    body.innerHTML = cart.items.map(function (item, idx) {
      return '<div class="cart-drawer-item">' +
        '<div class="cart-drawer-thumb">' + (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '">' : '') + '</div>' +
        '<div class="cart-drawer-info">' +
          '<div class="cart-drawer-name">' + escapeHtml(item.product_title) + '</div>' +
          '<div class="cart-drawer-size">' + escapeHtml(item.variant_title || '') + ' &times; ' + item.quantity + '</div>' +
          '<div style="display:flex;justify-content:space-between;align-items:center;">' +
            '<span class="cart-drawer-price">' + formatMoney(item.final_line_price) + '</span>' +
            '<button class="cart-drawer-rm" data-key="' + escapeHtml(item.key) + '">REMOVE</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    body.querySelectorAll('.cart-drawer-rm').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateCartLine(btn.dataset.key, 0);
      });
    });
  }
  function updateCartLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        refreshCartCount();
        renderCartDrawer(cart);
      });
  }
  function formatMoney(cents) {
    var rawSymbol = document.body.dataset.currencySymbol || '';
var symbol = rawSymbol.replace(/[{}]/g, '').trim() || '₹';
    return symbol + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  /* ---------- SHOP FILTER (collection page tag filter, client-side) ---------- */
  window.filterShop = function (cat, btn) {
    if (btn) {
      document.querySelectorAll('.shop-filter-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
    }
    var cats = cat.split(' ');
    document.querySelectorAll('#shopGrid .product-card').forEach(function (c) {
      var show = cat === 'all' || cats.indexOf(c.dataset.cat) > -1;
      c.style.display = show ? '' : 'none';
    });
  };

  /* ---------- ACCORDION (product page) ---------- */
  window.toggleAcc = function (head) {
    var item = head.parentElement;
    var wasOpen = item.classList.contains('open');
    item.parentElement.querySelectorAll('.acc-item').forEach(function (i) { i.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  };

  /* ---------- SIZE GUIDE MODAL ---------- */
  window.openSizeGuide = function () {
    var el = document.getElementById('sizeGuideModal');
    if (el) el.classList.add('open');
  };
  window.closeSizeGuide = function () {
    var el = document.getElementById('sizeGuideModal');
    if (el) el.classList.remove('open');
  };

  /* ---------- NEWSLETTER (Shopify customer form handles actual submission) ---------- */
  window.handleNlSuccess = function () {
    showToast("You're on the list");
  };

  /* ---------- FADE-IN ON SCROLL ---------- */
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('vis');
    });
  }, { threshold: 0.07 });
  document.querySelectorAll('.fi').forEach(function (el) { obs.observe(el); });
/* ==========================================
   PRODUCT TYPE FILTER
   ========================================== */

window.filterProducts = function(type, btn){

    // Active button
    document.querySelectorAll(".shop-filter-btn").forEach(function(b){
        b.classList.remove("active");
    });

    if(btn){
        btn.classList.add("active");
    }

    // Filter products
    document.querySelectorAll("#shopGrid .product-card").forEach(function(card){

        var productType = (card.dataset.type || "").trim();

        if(type === "all"){
            card.style.display = "";
            return;
        }

        if(productType.toLowerCase() === type.toLowerCase()){
            card.style.display = "";
        }else{
            card.style.display = "none";
        }

    });

};


/* ==========================================
   AUTO FILTER FROM HOMEPAGE CATEGORY
   ========================================== */

(function(){

    var params = new URLSearchParams(window.location.search);
    var type = params.get("type");

    if(!type) return;

    window.addEventListener("load", function(){

        var button = document.querySelector(
            '.shop-filter-btn[data-type="' + type + '"]'
        );

        if(button){
            filterProducts(type, button);
        }

    });

})();

/* ---------- COUNTDOWN ---------- */
  document.querySelectorAll('[data-countdown-date]').forEach(function (section) {
    var targetDate = new Date(section.dataset.countdownDate);
    if (isNaN(targetDate.getTime())) {
      // Invalid or empty date entered in the customizer — hide the timer instead of showing NaN.
      var timerEl = section.querySelector('.cd-timer');
      if (timerEl) timerEl.style.display = 'none';
      return;
    }
    var daysEl = section.querySelector('[data-cd-days]');
    var hoursEl = section.querySelector('[data-cd-hours]');
    var minsEl = section.querySelector('[data-cd-mins]');
    var secsEl = section.querySelector('[data-cd-secs]');
    function tick() {
      var diff = targetDate - new Date();
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minsEl) minsEl.textContent = String(m).padStart(2, '0');
      if (secsEl) secsEl.textContent = String(s).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  });

});
